export default {
    SEARCH: 'Sök',
    CATEGORY: 'Kategorier',
    CREATE_AD: 'Skapa annons',
    WISHLIST: 'Minneslista',
    LOGIN: 'Logga in',
    REGISTER: 'Registrera dig',
    ONGOING_AUCTIONS: 'Pågående budgivningar',
    I_UNDERSTAND: 'Jag förstår',
    IFRAME_NOT_SUPPORTED: 'Din browser saknar stöd för iframes',
    COOKIES: {
        HEADER: 'Information om cookies',
        DESC:
            'Tradera använder cookies (kakor) för att ge dig en bättre upplevelse.',
        READ_MORE: 'Läs mer om vårt användande av cookies.'
    },
    WELCOME_TO_TRADERA: 'Välkommen till Sveriges största marknadsplats!',
    ENDS: 'Slutar',
    BIDS: 'Bud',
    PRICE: 'Pris',
    DESC: 'Beskrivning',
    SHOW_FULL_DESC: 'Visa hela beskrivningen',
    VIEW_FULL_LISTING: 'Se hela annonsen',
    NEXT: 'Nästa',
    PREVIOUS: 'Föregående',
    ADVANCED_SEARCH: 'Avancerad sökning',
    SELLER_SEARCH: 'Sök efter säljare',
    WATCHLIST: 'Bevakningar',
    TO_BUY: 'Så köper du',
    TO_SELL: 'Så säljer du',
    GET_STARTED_BUYING: 'Kom igång med att handla på Tradera',
    GET_STARTED_SELLING: 'Kom igång med att sälja på Tradera',
    VIEW_MORE_VIDEOS: 'Se fler videos',
    CONTACT_SELF_TEXT: 'Du kan inte kontakta dig själv.',
    MY_TRADERA: {
        MESSAGING_OPT_IN:
            'Skicka och ta emot meddelanden från köpare/säljare via Tradera.',
        MESSAGING_OPT_IN_INFO: '(Valbart som butik eller företagssäljare)',
        MESSAGING_EMAIL_SETTING:
            'Skicka alltid mailkopia för alla lästa meddelanden'
    },
    DISCOVER: {
        FILTERS: {
            ALL_CATEGORIES: 'Alla kategorier',
            BRANDS: 'Varumärken',
            CONDITION: 'Skick',
            ITEM_TYPE: 'Annonsformat',
            PRICE: 'Pris',
            SELLER_TYPE: 'Typ av säljare',
            COUNTY: 'Område',
            ITEM_STATUS: 'Status',
            SORTING: 'Sortering',
            CLEAR: 'Återställ'
        },
        SAVE_SEARCH: 'Skapa bevakning',
        SAVE_SEARCH_SAVED: 'Bevakning skapad',
        SAVE_SEARCH_TOOLTIP:
            'Vill du få ett mejl när det du letar efter läggs upp på Tradera? Skapa då en bevakning.',
        SAVE_SEARCH_NOTIFICATION: 'Meljbevakning aktiverad'
    },
    META: {
        DEFAULT_SITE_NAME: 'Tradera',
        DEFAULT_DESCRIPTION:
            'Köp och sälj bland auktioner och till fast pris på Tradera.com. Fynda bland massor av auktioner.'
    }
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/constants/strings.js